var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVector22(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 4,
    height: 440,
    viewBox: "0 0 4 440",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 0.5V46.5M2 209.5V244.5M2 404V440",
    stroke: "#C9C9C9",
    strokeWidth: 3,
    strokeDasharray: "14 14"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector22);
export default __webpack_public_path__ + "static/media/Vector 22.5968dcf794fe3ca53bc8a8fd34856ab5.svg";
export { ForwardRef as ReactComponent };